import { Box, createStyles, Divider, Grid, GridSize, makeStyles, Theme } from "@material-ui/core";
import { GridItemProps } from "../models/GridItemProps";
import { InvoiceProps } from "../models/InvoiceProps";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    box: {
      marginTop: theme.spacing(1)
    },
    [theme.breakpoints.down('xs')]: {
      box: {
        flexDirection: 'column',
        '& > *': {
          justifyContent: 'center'
        }
      },
      marginTopMd: {
        marginTop: theme.spacing(1)
      }
    },
    amountAlignment: {
      textAlign: 'left'
    },
    '@media print': {
      noWrap: {
        whiteSpace: 'nowrap'
      },
      amountAlignment: {
        textAlign: 'center'
      },
      box: {
        paddingTop: theme.spacing(0),
        paddingBottom: theme.spacing(0)
      }
    }
  })
);


const gridSizes = {
  label: {
    xs: 8 as GridSize,
    sm: 4 as GridSize,
    lg: 2 as GridSize
  },
  value: {
    sm: 6 as GridSize,
    md: 8 as GridSize,
    lg: 9 as GridSize
  }
};

const GridAmount : React.FunctionComponent<GridItemProps> = ({label, value}) => {
  const classes = useStyles();

    value = value as number < 0 
      ? `-£${Math.abs(value as number)}` 
      : `£${value}`;

    return (
      <>
        <Grid item {...gridSizes.label} className={classes.noWrap}>
          {label} :
        </Grid>
        <Grid item {...gridSizes.value} className={classes.amountAlignment}>
          {value}
        </Grid>
      </>
    );
}

const InvoiceAmount : React.FunctionComponent<InvoiceProps> = ({ invoice }) => {
  const classes = useStyles();
  const { amount, outstandingAmount, notes } = invoice!;

  return (
    <Box display="flex" p={1} className={classes.box}>
        <Grid container item xs={12} sm={8} md={12} lg={10}>
            <GridAmount label='Amount ex vat' value={amount.amountExVat.toFixed(2)}/>
            <GridAmount label='Vat total' value={amount.vatTotal.toFixed(2)}/>
            <GridAmount label='Total' value={amount.amountIncVat.toFixed(2)}/>
            <GridAmount label='Outstanding amount' value={outstandingAmount.amountIncVat.toFixed(2)}/>
        </Grid>
        <Grid container item xs={12} sm={8} md={6} lg={4} className={classes.marginTopMd}>
        {notes && notes.length && 
              <>
                <Box p={1}>
                    {notes}
                </Box>
                <Divider variant="middle" />
              </>
          }
        </Grid>
    </Box>
  );
}

export default InvoiceAmount;